import React, {useEffect, useState} from 'react';
import {NUEVOS_POSTULANTES_FICHA_STEPS} from '../../../../constants/hardCodedConstants';
import {useManageGetRequest} from '../../../../hooks/useManageGetRequest/useManageGetRequest';
import useDidMountEffect from '../../../../hooks/useDidMountEffect/useDidMountEffect';
import PruebaPsicologicaI from './SectionsEdit/PruebaPsicologicaI';
import PruebaTecnica from './SectionsEdit/PruebaTecnica';
import PruebaPsicologicaII from './SectionsEdit/PruebaPsicologicaII';
import innova from "../../../../image/innova.png";
import backgroungImage from "../../../../image/postulante_background.png";
import {Wrapper} from "../../../../components/atoms/WrapperPostulante";
import ModalEnabled from '../../../../components/modalComponents/ModalEnabled';
import Stepper from '../globalComponents/Stepper';
import SendModalValidacion from '../modales/SendModalValidacion';
import { enviarDocumentosAprobacionNuevoIngresoAPI, getDatosEmpresaGestionAPI } from '../../../../consumers/backendApisUrls';

const DatosPersonalesEditarGlobalNuevosPostulantes = ({ idNuevosIngresosEmpleado, manageSearchActividadesPendientes, manageSearchListaDocumentos, documents, signature, puedeGestionarFirma, isColaborador, isOnlyDocuments = false, isObservated = false, fichaStep = 1, isActividadPendiente = false, widthDatosGlobal = "w-75", initStep = NUEVOS_POSTULANTES_FICHA_STEPS.stepOne.id, toggleParentModal, urlInstructivoFirma, tieneHijos = false }) => {

  const ID_PARENT = "editarDatospersonalesConId";
  const PASO_4_FICHA_NUEVOS_INGRESOS = 4;

  const [commonStates, setCommonStates] = useState({});
  const [currentStep, setCurrentStep] = useState(initStep);
  const [sendCurrentStep, setSendCurrentStep] = useState({step: 0, isSent: false});
  const [modalEnable, setModalEnable] = useState({isEnable: false});

  const [executeGet] = useManageGetRequest();

  const [isClickStart, setIsClickStart] = useState(false);

  const commonProps = () => {
    return {
      idNuevosIngresosEmpleado,
      idParent: ID_PARENT,
      isColaborador,
      sendCurrentStep,
      setSendCurrentStep
    }
  }

  const stepComponents = {
    [NUEVOS_POSTULANTES_FICHA_STEPS.stepOne.id]: {component: <PruebaTecnica {...commonProps()} manageSearchListaDocumentos={manageSearchListaDocumentos}/>, name: "Prueba Técnica"},
    [NUEVOS_POSTULANTES_FICHA_STEPS.stepTwo.id]: {component: <PruebaPsicologicaI {...commonProps()} commonStates={commonStates}/>, name: "Prueba Psicológica I"},
    [NUEVOS_POSTULANTES_FICHA_STEPS.stepThree.id]: {component: <PruebaPsicologicaII {...commonProps()}/>, name: "Prueba Psicológica II"},
  }

  const getDatosEmpresa = async () => {
    const api = getDatosEmpresaGestionAPI(idNuevosIngresosEmpleado);
    return await executeGet(api, successManageSearchCallback)
  }

  const successManageSearchCallback = ({ data }) => {
    let { IdTipoEmpleado, IdTipoTrabajador, IdCargo } = data;
    setCommonStates(lastData => ({...lastData, IdTipoEmpleado, IdTipoTrabajador, IdCargo }));
  }

  const handleClick = (clickType) => {
		let newStep = currentStep;
    if (clickType === "save"){
      setSendCurrentStep({step: currentStep, isSent: true});
    } else {
      validateStep(--newStep);
    }
	}

  const validateStep = (newStep) => {
    if (newStep > 0 && newStep <= Object.keys(NUEVOS_POSTULANTES_FICHA_STEPS).length) {
      setCurrentStep(newStep);
    }
  }

  useDidMountEffect(() => {
    if(sendCurrentStep.isSaved && !sendCurrentStep.isSent){
      let newStep = currentStep;
      validateStep(++newStep);
      setSendCurrentStep({step: 0, isSent: false})
    } else {
      setSendCurrentStep({step: currentStep, isSent: false});
    }
  }, [sendCurrentStep.isSaved])

  useEffect(() => {
    getDatosEmpresa();
  }, [])

  let stepsToRender = []
  if (isOnlyDocuments){
    stepsToRender = fichaStep < PASO_4_FICHA_NUEVOS_INGRESOS
      ? [stepComponents[NUEVOS_POSTULANTES_FICHA_STEPS.stepSeven.id]]
      : tieneHijos
        ? [stepComponents[NUEVOS_POSTULANTES_FICHA_STEPS.stepSix.id], stepComponents[NUEVOS_POSTULANTES_FICHA_STEPS.stepSeven.id]]
        : [stepComponents[NUEVOS_POSTULANTES_FICHA_STEPS.stepSeven.id]]
  } else {
    if (fichaStep < PASO_4_FICHA_NUEVOS_INGRESOS){
      stepsToRender = Object.entries(stepComponents)
        .filter(([key]) => Number(key) !== Number(NUEVOS_POSTULANTES_FICHA_STEPS.stepSix.id))
        .map(([, value]) => value);
    } else {
      stepsToRender = Object.values(stepComponents);
    }
  }

  const iniciar = () => {
      setIsClickStart(true);
  };

  return (
      !isClickStart ?
          <Wrapper>
              <div className='inicial'>
                  <div className='backgroung'>
                      <img src={backgroungImage} style={{width: '2000px'}}/>
                  </div>
                  <div className='wrapperButtons'>
                      <div className='container-button'>
                          <img src={innova} alt='' style={{width: '50%'}}/>
                      </div>
                      <div className='container-button-mob'>
                          <img src='https://intranetinnova.github.io/IntranetFileRepository/Logos/innova_mob.png' alt=''
                               style={{width: '50%'}}/>
                      </div>
                      <br></br>

                      <div className="subtitle">PRUEBA TÉCNICA Y PSICOLÓGICA</div>

                      <p className="text">
                          <strong>¡Bienvenido(a) al siguiente paso de tu postulación!</strong><br></br>
                          Estimado(a) Postulante, a continuación, deberás rendir una prueba de conocimiento
                          y dos cuestionarios psicológicos para continuar con el proceso de selección;
                          te recomendamos buscar un espacio tranquilo y con buena conexión.
                      </p>
                      <p className="text">
                          Cuando te encuentres completamente listo(a), da clic en el botón
                          <strong>INICIAR</strong> que se encuentra abajo.
                      </p>
                      <div className="button">
                          <button onClick={iniciar}>Iniciar</button>
                      </div>
                  </div>
              </div>
          </Wrapper>
    :
          <div className={`${widthDatosGlobal} m-auto`}>
              <ModalEnabled modalEnabled={modalEnable} setModalEnabled={setModalEnable} />
              {stepsToRender.length > 1 &&
                  <Stepper steps={stepsToRender.map(step => step.name)} currentStepNumber={currentStep} setCurrentStepNumber={setCurrentStep} isObservated={isObservated}/>
              }
              {React.cloneElement(stepsToRender[currentStep - 1].component, { componentStep: currentStep })}
              <div className="d-flex justify-content-around py-4" style={{borderTop: "1px solid #dee2e6"}}>
                  {currentStep !== NUEVOS_POSTULANTES_FICHA_STEPS.stepOne.id &&
                      <button onClick={() => handleClick()} className="btn btn-primary generic-button-ficha-modal"> Atrás </button>
                  }
                  {currentStep !== stepsToRender.length
                      ? <button type='button' onClick={() => handleClick("save")} className="btn generic-button-buscador generic-button-hover-verde" style={{backgroundColor: "#8DBA38"}}>Enviar y Continuar</button>
                      : <button type='button' onClick={() => setModalEnable({isEnable: true, component: SendModalValidacion, data: {id: idNuevosIngresosEmpleado, api: enviarDocumentosAprobacionNuevoIngresoAPI, actionLabel: "enviar", name: "Ficha Colaborador", titulo:"Enviar Ficha y Documentos", setModalEnable, isActividadPendiente, manageSearchActividadesPendientes, toggleParentModal }})} className="btn generic-button-buscador generic-button-hover-verde green-innova-background">Guardar y Enviar</button>
                  }
              </div>
          </div>
  )
}

export default DatosPersonalesEditarGlobalNuevosPostulantes;